import { t } from "i18next"
import { capitalizeFirstLetter } from "utils"

const getUserData = (item, parentId) => {
  let obj
  if (item?.data) {
    obj = {
      ...item.data,
      id: item.data.userId,
      userId: item.data.userId,
      name: item.data.name,
      nameAr: item.data.nameAr,
      reporteesCount: item.data.totalMembers + " " + t("Members"),
      designation: item.data.designation,
      parentId: parentId,
      ...(item?.children && { children: item.children.map(e => getUserData(e, item.data.userId)) }),
    }
  } else {
    obj = {
      ...item,
      type: "region",
      id: item?.cities ? "region-" + item?.regionId : item?.cityId,
      name: item?.cityName || item.regionName,
      parentId: parentId,
      ...(item?.cities && {
        children: item.cities.map(e => getUserData(e, item?.cities ? "region-" + item?.regionId : item?.cityId)),
      }),
    }
  }
  return obj
}

export const forecastedProjectionTransformer = response => {
  // let response = {
  //   "forecasted_table": {
  //     "data": [
  //       {
  //         "data": {
  //           "userId": 773270,
  //           "name": "Akasha Habib",
  //           "designation": "SR-MGR",
  //           "tenure": "",
  //           "lineManagerId": 772963,
  //           "totalMembers": 2,
  //           "conversion_probability_sc_ai": {
  //             "total": 1000000,
  //             "greaterThanOrEqual10": 900000,
  //             "greaterThanOrEqual20": 800000,
  //             "greaterThanOrEqual30": 700000,
  //             "greaterThanOrEqual40": 600000,
  //             "greaterThanOrEqual50": 500000,
  //             "greaterThanOrEqual60": 400000,
  //             "greaterThanOrEqual70": 300000,
  //             "greaterThanOrEqual80": 200000,
  //             "greaterThanOrEqual90": 100000,
  //             "greaterThanOrEqual100": 50000
  //           },
  //           "percentage": {
  //             "conversion_probability_sc_ai": {
  //               "total": 100,
  //               "greaterThanOrEqual10": 90,
  //               "greaterThanOrEqual20": 80,
  //               "greaterThanOrEqual30": 70,
  //               "greaterThanOrEqual40": 60,
  //               "greaterThanOrEqual50": 50,
  //               "greaterThanOrEqual60": 40,
  //               "greaterThanOrEqual70": 30,
  //               "greaterThanOrEqual80": 20,
  //               "greaterThanOrEqual90": 15,
  //               "greaterThanOrEqual100": 10
  //             }
  //           }
  //         },
  //         "children": [
  //           {
  //             "data": {
  //               "userId": 777340,
  //               "name": "Saran Gill",
  //               "designation": "BDA",
  //               "tenure": "",
  //               "lineManagerId": 773270,
  //               "totalMembers": 1,
  //               "conversion_probability_sc_ai": {
  //                 "total": 300000,
  //                 "greaterThanOrEqual10": 270000,
  //                 "greaterThanOrEqual20": 240000,
  //                 "greaterThanOrEqual30": 210000,
  //                 "greaterThanOrEqual40": 180000,
  //                 "greaterThanOrEqual50": 150000,
  //                 "greaterThanOrEqual60": 120000,
  //                 "greaterThanOrEqual70": 90000,
  //                 "greaterThanOrEqual80": 60000,
  //                 "greaterThanOrEqual90": 40000,
  //                 "greaterThanOrEqual100": 20000
  //               },
  //               "percentage": {
  //                 "conversion_probability_sc_ai": {
  //                   "total": 100,
  //                   "greaterThanOrEqual10": 90,
  //                   "greaterThanOrEqual20": 80,
  //                   "greaterThanOrEqual30": 70,
  //                   "greaterThanOrEqual40": 60,
  //                   "greaterThanOrEqual50": 50,
  //                   "greaterThanOrEqual60": 40,
  //                   "greaterThanOrEqual70": 30,
  //                   "greaterThanOrEqual80": 20,
  //                   "greaterThanOrEqual90": 15,
  //                   "greaterThanOrEqual100": 10
  //                 }
  //               }
  //             },
  //             "children": []
  //           }
  //         ]
  //       }
  //     ],
  //     "staticKeys": {
  //       "conversion_probability_sc_ai": {
  //         "label": "Conversion Probability",
  //         "order": 1,
  //         "short": "Conversion Probability",
  //         "total": {
  //           "type": "currency",
  //           "label": "TOTAL",
  //           "order": 1,
  //           "short": "TOTAL",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Total revenue"
  //         },
  //         "default": true,
  //         "description": "Conversion probability",
  //         "greaterThanOrEqual10": {
  //           "type": "currency",
  //           "label": ">= 10%",
  //           "order": 2,
  //           "short": ">= 10%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 10%"
  //         },
  //         "greaterThanOrEqual20": {
  //           "type": "currency",
  //           "label": ">= 20%",
  //           "order": 3,
  //           "short": ">= 20%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 20%"
  //         },
  //         "greaterThanOrEqual30": {
  //           "type": "currency",
  //           "label": ">= 30%",
  //           "order": 4,
  //           "short": ">= 30%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 30%"
  //         },
  //         "greaterThanOrEqual40": {
  //           "type": "currency",
  //           "label": ">= 40%",
  //           "order": 5,
  //           "short": ">= 40%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 40%"
  //         },
  //         "greaterThanOrEqual50": {
  //           "type": "currency",
  //           "label": ">= 50%",
  //           "order": 6,
  //           "short": ">= 50%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 50%"
  //         },
  //         "greaterThanOrEqual60": {
  //           "type": "currency",
  //           "label": ">= 60%",
  //           "order": 7,
  //           "short": ">= 60%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 60%"
  //         },
  //         "greaterThanOrEqual70": {
  //           "type": "currency",
  //           "label": ">= 70%",
  //           "order": 8,
  //           "short": ">= 70%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 70%"
  //         },
  //         "greaterThanOrEqual80": {
  //           "type": "currency",
  //           "label": ">= 80%",
  //           "order": 9,
  //           "short": ">= 80%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 80%"
  //         },
  //         "greaterThanOrEqual90": {
  //           "type": "currency",
  //           "label": ">= 90%",
  //           "order": 10,
  //           "short": ">= 90%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 90%"
  //         },
  //         "greaterThanOrEqual100": {
  //           "type": "currency",
  //           "label": ">= 100%",
  //           "order": 11,
  //           "short": ">= 100%",
  //           "default": true,
  //           "percentage": true,
  //           "description": "Conversion probability greater than or equal to 100%"
  //         }
  //       }
  //     }
  //   },
  //   "teamTypes": "sales,secondarySales,salesaff",
  //   "filters": {}
  // }
  let listKeys = []

  const forecastedTable = response?.forecasted_table || {}
  const staticKeys = forecastedTable?.staticKeys || {}

  const parentKeys = Object.keys(staticKeys)
    .map(parentKey => ({
      parentKey,
      order: staticKeys[parentKey]?.order ?? 0,
    }))
    .sort((a, b) => a.order - b.order)

  parentKeys.map(({ parentKey }) => {
    const children = Object.keys(staticKeys[parentKey] || {})
      .filter(childKey => {
        if (childKey === "order" || childKey === "label") return false
        const childValue = staticKeys[parentKey][childKey]
        return childValue && typeof childValue === "object" && !Array.isArray(childValue)
      })
      .map(childKey => {
        const { order, ...childData } = staticKeys[parentKey][childKey] || {}
        return {
          type: childData?.type || "number",
          ...childData,
          key: childKey,
          showPercentage: childData?.percentage || false,
          parent: parentKey,
          order: order ?? 0,
          short: childData?.short || childData?.label || capitalizeFirstLetter(childKey),
          label: childData?.label || t(capitalizeFirstLetter(childKey)),
        }
      })
      .sort((a, b) => a.order - b.order)
    if (children.length > 0) {
      listKeys.push({
        key: parentKey,
        label: staticKeys[parentKey]?.label || t(capitalizeFirstLetter(parentKey)),
        title: staticKeys[parentKey]?.label || t(capitalizeFirstLetter(parentKey)),
        children,
      })
    }
  })

  const userKpi = {
    ...forecastedTable,
    data:
      (forecastedTable?.data?.length > 0 &&
        forecastedTable.data.map(item => getUserData(item, item?.data?.userId || item?.regionId))) ||
      [],
  }

  return {
    ...response,
    listKeys,
    userKpi,
  }
}
